var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiBien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24C1.5 29.9674 3.87053 35.6903 8.0901 39.9099C12.3097 44.1295 18.0326 46.5 24 46.5C29.9674 46.5 35.6903 44.1295 39.9099 39.9099C44.1295 35.6903 46.5 29.9674 46.5 24C46.5 18.0326 44.1295 12.3097 39.9099 8.0901C35.6903 3.87053 29.9674 1.5 24 1.5C18.0326 1.5 12.3097 3.87053 8.0901 8.0901C3.87053 12.3097 1.5 18.0326 1.5 24V24Z",
    stroke: "#FAAF0C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.25C16.6483 17.25 16.7933 17.294 16.9167 17.3764C17.04 17.4588 17.1361 17.5759 17.1929 17.713C17.2497 17.85 17.2645 18.0008 17.2356 18.1463C17.2066 18.2918 17.1352 18.4254 17.0303 18.5303C16.9254 18.6352 16.7918 18.7066 16.6463 18.7356C16.5008 18.7645 16.35 18.7497 16.213 18.6929C16.0759 18.6361 15.9588 18.54 15.8764 18.4167C15.794 18.2933 15.75 18.1483 15.75 18C15.75 17.8011 15.829 17.6103 15.9697 17.4697C16.1103 17.329 16.3011 17.25 16.5 17.25",
    stroke: "#FAAF0C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17.25C31.6483 17.25 31.7933 17.294 31.9167 17.3764C32.04 17.4588 32.1361 17.5759 32.1929 17.713C32.2497 17.85 32.2645 18.0008 32.2356 18.1463C32.2066 18.2918 32.1352 18.4254 32.0303 18.5303C31.9254 18.6352 31.7918 18.7066 31.6463 18.7356C31.5008 18.7645 31.35 18.7497 31.213 18.6929C31.0759 18.6361 30.9588 18.54 30.8764 18.4167C30.794 18.2933 30.75 18.1483 30.75 18C30.75 17.8011 30.829 17.6103 30.9697 17.4697C31.1103 17.329 31.3011 17.25 31.5 17.25",
    stroke: "#FAAF0C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.096 30C34.9789 32.2545 33.2541 34.1521 31.1161 35.4787C28.9782 36.8054 26.5121 37.5083 23.996 37.5083C21.4799 37.5083 19.0138 36.8054 16.8759 35.4787C14.7379 34.1521 13.0131 32.2545 11.896 30",
    stroke: "#FAAF0C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiBien);
export default __webpack_public_path__ + "static/media/emoji-bien.95b1f770374dc826cc6b0332b41122fb.svg";
export { ForwardRef as ReactComponent };